<template>
    <x-page :title="pageTitle">
        <template #header-actions>
            <x-back-button :disabled="isLoading" />
        </template>

        <translation-draft-form
            id="translation-draft-form"
            v-if="Boolean(resource)"
            @submit="handleSubmit"
            :disabled="isLoading"
            :errors="errors"
            :initialFields="resource"
        />

        <template #footer>
            <x-submit-button
                form="translation-draft-form"
                :is-loading="isLoading"
                :disabled="isLoading"
            />
        </template>
    </x-page>
</template>

<script>
import XBackButton from "../../components/XBackButton.vue";
import XPage from "../../components/XPage.vue";
import XSubmitButton from "../../components/XSubmitButton.vue";
import { handleGeneralXhrError, handleValidationXhrError } from "../../helpers";
import FormDataMixin from "../../mixins/FormDataMixin";
import TranslationDraftForm from "./TranslationDraftForm.vue";

export default {
    components: {
        XPage,
        XBackButton,
        XSubmitButton,
        TranslationDraftForm,
    },
    computed: {
        pageTitle() {
            let title = [
                "Edit",
                this.resource ? this.resource.title : "Draft Terjemahan",
            ];
            return title.join(" | ");
        },
    },
    created() {
        this.fetchResource();
    },
    data() {
        return {
            errors: null,
            isLoading: false,
            resource: null,
        };
    },
    methods: {
        fetchResource() {
            this.isLoading = true;
            const request = axios
                .get(`/api/translation-drafts/${this.$route.params.id}`)
                .then((response) => {
                    this.resource = response.data.data;
                });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
        handleSubmit(fields) {
            this.isLoading = true;

            fields.append("_method", "PATCH");

            const request = axios
                .post(
                    `/api/translation-drafts/${this.$route.params.id}`,
                    fields,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                )
                .then((response) => {
                    this.$notify({
                        type: "success",
                        title: `Berhasil`,
                        text: `${response.data.data.title} updated!`,
                    });
                    this.$router.back();
                });
            return handleValidationXhrError(request, (errors) => {
                this.errors = errors;
                this.isLoading = false;
            });
        },
    },
    mixins: [FormDataMixin],
};
</script>
